document.querySelector<HTMLDivElement>("#app")!.innerHTML = ``;

import fahrzeugUrl from "/assets/leiterAnimation/Fahrzeug.png";
import leiterUrl from "/assets/leiterAnimation/Leiter.png";
import korbUrl from "/assets/leiterAnimation/Korb.png";

const canvas = document.querySelector<HTMLCanvasElement>("#canvas")!;
const ctx = canvas.getContext("2d")!;

canvas.width = canvas.offsetWidth;
canvas.height = canvas.offsetHeight;

console.log(canvas.width, canvas.height);

let imgScale = 1 / 3;

if (canvas.width < 400) imgScale = 1 / 5;

let check = 0;
const fahrzeug = new Image();
fahrzeug.src = fahrzeugUrl;
fahrzeug.onload = loadCheck;
const leiter = new Image();
leiter.src = leiterUrl;
leiter.onload = loadCheck;
const korb = new Image();
korb.src = korbUrl;
korb.onload = loadCheck;

function loadCheck() {
  check++;

  if (check < 3) return;
  draw(0);
}

const rotPoint = { x: 800 * imgScale, y: 850 * imgScale };
const length = 740 * imgScale;
const angleOffset = Math.PI / 3.1;

function draw(angle: number) {
  lastAngle = angle;
  ctx.clearRect(-1000, -1000, canvas.width * 10, canvas.width * 10);

  ctx.translate(
    canvas.width - fahrzeug.width * imgScale,
    canvas.height - fahrzeug.height * imgScale
  );

  ctx.save();

  ctx.translate(rotPoint.x, rotPoint.y);

  ctx.translate(
    -Math.cos(angle + angleOffset) * length,
    -Math.sin(angle + angleOffset) * length
  );

  ctx.drawImage(
    korb,
    -135 * 3 * imgScale,
    -70 * 3 * imgScale,
    fahrzeug.width * imgScale,
    fahrzeug.height * imgScale
  );

  ctx.translate(
    Math.cos(angle + angleOffset) * length,
    Math.sin(angle + angleOffset) * length
  );

  ctx.rotate(angle);

  ctx.drawImage(
    leiter,
    -rotPoint.x,
    -rotPoint.y,
    fahrzeug.width * imgScale,
    fahrzeug.height * imgScale
  );

  ctx.restore();

  ctx.drawImage(
    fahrzeug,
    0,
    0,
    fahrzeug.width * imgScale,
    fahrzeug.height * imgScale
  );
  ctx.resetTransform();
}

let lastAngle = 0;
canvas.addEventListener("resize", () => draw(lastAngle));

document.addEventListener("mousemove", (event) => {
  const dx = document.body.clientWidth - event.clientX;
  const dy = document.body.clientHeight - event.clientY;

  const angleRadians = Math.atan2(dy, dx);
  if (dy > 100 && dx > 100) draw(angleRadians - angleOffset);
});
